/* eslint-disable no-unused-vars */
import { useSelector, useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { IconButton } from 'components';
import { creativesActions } from 'store/campaign/creatives';
import { PictureIcon } from 'assets/icons';
import { ImageWithFallback, ParagraphWithTooltip } from 'components';
import { Delete } from 'assets/icons';

export const BannerItem = ({ previewSectionImage$, item, currentSelectedSize$, isDisabled }) => {
  const dispatch = useDispatch();
  const banners = useSelector((state) => state?.creatives?.selectedCreative?.banners);

  const handleDeleteItem = () => {
    if (isDisabled) return;

    const newBanners = banners.filter((banner) => banner.media_id !== item.media_id);
    dispatch(
      creativesActions.updateProperty({
        propField: 'banners',
        newValue: newBanners,
      }),
    );
    previewSectionImage$.value = null;
    currentSelectedSize$.value = '';
  };

  const handleItemClick = () => {
    if (isDisabled) return;

    previewSectionImage$.value = item;
  };

  return (
    <CreativeItem isSelected={previewSectionImage$.value?.media_id === item?.media_id}>
      <Box onClick={handleItemClick}>
        <IconBox>
          <PictureIcon />
        </IconBox>
        <ImageWithFallback
          key={item.media_id}
          width='32px'
          height='32px'
          src={`https://cdn.appnext.com/banner/${item.file_name}`}
        />
        <NameBox>
          <ParagraphWithTooltip text={`${item.file_name || 'no file name'}`} />
        </NameBox>
        <Size>{item.image_size}</Size>
      </Box>
      <DeleteIconBox>
        <IconButton.NormalSize
          icon={() => <Delete style={{ fill: '#64748b' }} />}
          disabled={false}
          type={IconButton.btnTypes.tertiary}
          onClick={handleDeleteItem}
        />
      </DeleteIconBox>
    </CreativeItem>
  );
};
const DeleteIconBox = styled.div`
  margin-left: auto;
`;

const Size = styled.p`
  margin-left: auto;
`;

const IconBox = styled.div`
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`;

const NameBox = styled.div`
  width: 47%;
  margin-left: 16px;
`;

const Box = styled.div`
  display: flex;
  align-items: center;

  width: 89%;
`;

const CreativeItem = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: flex;
  align-items: center;
  height: 48px;

  padding: 8px;
  border-radius: 4px;
  border: 1px solid white;

  cursor: pointer;
  svg {
    fill: #64748b;
  }
  :hover {
    background: ${Palette.PrimaryGray._100};
    svg {
      fill: #3b89f6;
    }
  }

  :active {
    border: 1px solid ${Palette.Primary._300};
    background: ${Palette.Primary._000};
    svg {
      fill: ${Palette.Primary._500};
    }
  }
  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 1px solid ${Palette.Primary._300};
      background: ${Palette.Primary._000};
      svg {
        fill: ${Palette.Primary._500};
      }
    `}
`;
